//测试环境
const upload_url = 'https://api.iztrv.com/admin/uploads';
const admin_api = 'https://api.iztrv.com/admin';
export default {
  upload_url,
  admin_api,
}
